import { useEffect, useState } from "react";

const SAMPLE = "Lorem ipsum dolor sit amet, consectetur adipiscing elit.";

/**
 * Sample text in one uploaded font file. The file is registered under a family name of its own
 * (brand-font-<id>-<format>) and removed again on unmount. A file's internal family name is shared by
 * its regular, bold and italic faces ("Open Sans"), so registering it under that name, as font-preview
 * does, adds faces the editor then picks up as regular "Open Sans" and renders its text bold or italic.
 */
const BrandFontPreview = ({ fontId, format, text = SAMPLE }) => {

    const family = `brand-font-${fontId}-${format}`;
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const face = new FontFace(family, `url(/api/fonts/brand/font/${fontId}.${format})`);
        let current = true;
        setLoaded(false);
        document.fonts.add(face);
        face.load()
            .then(() => current && setLoaded(true))
            .catch(() => current && setLoaded(false));
        return () => {
            current = false;
            document.fonts.delete(face);
        };
    }, [family, fontId, format]);

    return <div className="font-preview" style={{ fontFamily: loaded ? `"${family}"` : undefined }}>{text}</div>;
}

export default BrandFontPreview;
